import React, { useState } from "react";
import "./Header.scss";
import logo from "../../assets/images/logos/techadive_logo.svg";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);

    const handleScrollTo = (sectionId) => {
        closeMenu();

        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => {
                const section = document.getElementById(sectionId);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                }
            }, 600);
        } else {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    return (
        <header className={`header ${menuOpen ? "open" : ""}`}>
            {/* Logo */}
            <div className="header__logo">
                <img
                    src={logo}
                    alt="Techadive Logo"
                    width="120"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (location.pathname !== "/") {
                            navigate("/");
                        } else {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }
                        closeMenu();
                    }}
                />
            </div>

            {/* Hamburger */}
            <div
                className={`header__menu-toggle ${menuOpen ? "active" : ""}`}
                onClick={toggleMenu}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Navigation */}
            <nav className={`header__nav ${menuOpen ? "show" : ""}`}>
                <button onClick={() => handleScrollTo("what-we-build")}>Services</button>
                <button onClick={() => handleScrollTo("tech-stack")}>Technology</button>
                <button onClick={() => handleScrollTo("use-cases")}>Use Cases</button>
                <a
                    href="/about"
                    onClick={(e) => {
                        e.preventDefault();
                        closeMenu();
                        navigate("/about");
                    }}
                >
                    About
                </a>

                {/* Contact button (shared, visible only on mobile) */}
                <button
                    className="header__cta header__cta--mobile"
                    onClick={() => {
                        closeMenu();
                        navigate("/contact");
                    }}
                >
                    Contact Us
                </button>
            </nav>

            {/* Desktop-only button */}
            <button
                className="header__cta header__cta--desktop"
                onClick={() => navigate("/contact")}
            >
                Contact Us
            </button>
        </header>
    );
};

export default Header;
